import {
  DAP_API,
  IAM_API,
  TALENAISE_BASE_URL,
  EVALTIQ_BASE_URL
} from "./config";

// IAM
export const GET_ALL_ROLES_FOR_ORG = `${IAM_API}/v1/api/user-role/organization/fetch-all`;
export const GET_ORG_USER = `${IAM_API}/v1/api/organization/customer-user/fetch-all-from-current-organization`;
export const ADD_ORG_USER = `${IAM_API}/v1/api/organization/customer-user/add-user-to-organization`;
export const MY_PROFILE_DETAILS = `${IAM_API}/v1/api/authentication/current-user-detail`;

export const FETCH_PROJECT_BY_ACCOUNT = `${IAM_API}/v1/api/project/customer-user/fetch-all-project`;
export const GET_PROJ_UNIQUE_USERS = `${IAM_API}/v1/api/project/customer-user/fetch-unique-users`;
export const GET_ALL_ROLES_FOR_CUSTOMER_PROJ = `${IAM_API}/v1/api/user-role/customer-user/project/fetch-all`;

// platform
export const CRUD_DIFFICULTY_LEVEL = `${TALENAISE_BASE_URL}/v1/api/difficulty-level`;
export const CRUD_COURSE_LEVEL = `${TALENAISE_BASE_URL}/v1/api/course-level`;
export const CRUD_PROFICIENCY_LEVEL = `${TALENAISE_BASE_URL}/v1/api/proficiency-level`;
export const CRUD_ASSESSMENT_METHOD = `${TALENAISE_BASE_URL}/v1/api/assessment-method`;

export const CRUD_RESPONSE_STATUS = `${TALENAISE_BASE_URL}/v1/api/response-status`;
export const CRUD_SKILL_ASSESSMENT_STATUS = `${TALENAISE_BASE_URL}/v1/api/skill-assessment-status`;
export const CRUD_COMPETENCY_FRAMEWORK_STATUS = `${TALENAISE_BASE_URL}/v1/api/competency-framework-status`;

export const CRUD_PROGRAMMING_LANGUGAGE = `${TALENAISE_BASE_URL}/v1/api/programming-language`;
export const GET_DETAILS_PROGRAMMING_LANGUAGE = `${TALENAISE_BASE_URL}/v1/api/programming-language/get-by-id`;

// Industry
export const GET_INDUSTRY = `${DAP_API}/v1/api/piedap/industry`;

// DOMAIN
export const GET_DOMAIN_BY_INDUSTRY = `${DAP_API}/v1/api/piedap/domain_by_industry`;


// Setup
// skill category
export const CRUD_SKILL_CATEGORY = `${TALENAISE_BASE_URL}/v1/api/skill-category`;
export const GET_SKILL_CATEGORY = `${TALENAISE_BASE_URL}/v1/api/skill-category/fetch-by-id`;

// skill group
export const CRUD_SKILL_GROUP = `${TALENAISE_BASE_URL}/v1/api/skill-group`;
export const GET_SKILL_GROUP = `${TALENAISE_BASE_URL}/v1/api/skill-group/fetch-by-id`;

// skill
export const CRUD_SKILL = `${TALENAISE_BASE_URL}/v1/api/skill`;
export const GET_SKILL = `${TALENAISE_BASE_URL}/v1/api/skill/fetch-by-id`;
export const GENERATE_SKILL = `${DAP_API}/v1/api/piedap/generate_skills_by_openai`;
export const STORE_GENERATED_SKILL = `${TALENAISE_BASE_URL}/v1/api/skill/bulk`;

// skill proficiency level
export const CRUD_SKILL_COURSE_LEVEL = `${TALENAISE_BASE_URL}/v1/api/skill-course-level`;
export const GET_SKILL_COURSE_LEVEL = `${TALENAISE_BASE_URL}/v1/api/skill-course-level/findBySkill`;

// Skill Area
export const CRUD_SKILL_AREA = `${TALENAISE_BASE_URL}/v1/api/skill-area`;
export const STORE_SKILL_AREA = `${TALENAISE_BASE_URL}/v1/api/skill-area/bulk`;
export const GET_SKILL_AREA = `${TALENAISE_BASE_URL}/v1/api/skill-area/get-by-skill`;
export const GET_SKILL_AREA_DETAILS = `${TALENAISE_BASE_URL}/v1/api/skill-area/fetch-by-id`;

// generate API
export const TALENAISE_GENERATE = `${DAP_API}/v1/api/piedap/generate_skill_area_by_ai`;

// Evaluation Criteria
export const CRUD_EVALUATION_CRITERIA = `${TALENAISE_BASE_URL}/v1/api/evaluation-criterion`;
export const STORE_EVALUATION_CRITERIA = `${TALENAISE_BASE_URL}/v1/api/evaluation-criterion/bulk`;
export const GET_EVALUATION_CRITERIA = `${TALENAISE_BASE_URL}/v1/api/evaluation-criterion/get-by-skill`;
export const GET_EVALUATION_CRITERIA_DETAILS = `${TALENAISE_BASE_URL}/v1/api/evaluation-criterion/fetch-by-id`;


// question bank
export const CRUD_QUESTION_BANK = `${TALENAISE_BASE_URL}/v1/api/question-bank`;
export const GET_QUESTION_BANK_DETAILS = `${TALENAISE_BASE_URL}/v1/api/question-bank/fetch-by-id`;
export const GET_QUESTION_STATUS_HISTORY = `${TALENAISE_BASE_URL}/v1/api/question-status-history`;
export const GENERATE_QUESTIONS_FOR_QUESTION_BANK = `${DAP_API}/v1/api/piedap/generate_skill_assessment_questions_by_openai`;
export const STORE_GEN_QUESTIONS_FOR_QUESTION_BANK = `${TALENAISE_BASE_URL}/v1/api/question-bank/bulk-create`;
export const DOWNLOAD_QUESTION_BANK_TEMPLATE = `${TALENAISE_BASE_URL}/v1/api/excel-parser/excel-download-question-bank-template`;
export const DOWNLOAD_QUESTION_BANK = `${TALENAISE_BASE_URL}/v1/api/excel-parser/excel-download-question-bank`;

export const UPLOAD_QUESTION_BANK = `${TALENAISE_BASE_URL}/v1/api/excel-parser/batch-upload-question-bank`;

// skill mapping
export const GET_ALL_SKILL = `${TALENAISE_BASE_URL}/v1/api/skill/get-all`;
export const CRUD_SKILL_MAPPING = `${TALENAISE_BASE_URL}/v1/api/skill-mapping`;
export const CRUD_SKILL_MAPPING_SETUP = `${TALENAISE_BASE_URL}/v1/api/skill-mapping-config`;
export const VALIDATE_MARKS_DURATION = `${TALENAISE_BASE_URL}/v1/api/skill-mapping/validate-marks-duration`;
export const VALIDATE_MARKS_DURATION_CONFIG = `${TALENAISE_BASE_URL}/v1/api/skill-mapping-config/validate-marks-duration`;
export const DIFFICULTY_LEVEL_MARKS = `${TALENAISE_BASE_URL}/v1/api/skill-mapping/difficulty-level-marks-duration`;
export const DIFFICULTY_LEVEL_MARKS_SETUP = `${TALENAISE_BASE_URL}/v1/api/skill-mapping-config/difficulty-level-marks-duration`;


export const GET_SKILL_MAPPING_BY_ID = `${TALENAISE_BASE_URL}/v1/api/skill-mapping/get-by-competency-framework`;
export const GET_SKILL_MAPPING_BY_ID_SETUP = `${TALENAISE_BASE_URL}/v1/api/skill-mapping-config/get-by-competency-framework`;

export const GET_SKILL_MAPPING_DETAILS = `${TALENAISE_BASE_URL}/v1/api/skill-mapping/get-by-id`;
export const GET_SKILL_MAPPING_DETAILS_SETUP = `${TALENAISE_BASE_URL}/v1/api/skill-mapping-config/get-by-id`;
export const DELETE_SKILL_MAPPING_QUESTION_TYPE_BY_ID = `${TALENAISE_BASE_URL}/v1/api/skill-mapping/delete-skill-mapping-question-type`;
export const DELETE_SKILL_MAPPING_QUESTION_CONFIG_TYPE_BY_ID = `${TALENAISE_BASE_URL}/v1/api/skill-mapping-config/delete-skill-mapping-question-type`;

export const GET_USER_DETAILS = `${DAP_API}/v1/api/piedap/user_detail_by_piedap_user_id`;

export const CRUD_QUESTION_TYPE = `${TALENAISE_BASE_URL}/v1/api/question-type`;


export const CRUD_ASSESSMENT_STATUS = `${EVALTIQ_BASE_URL}/v1/api/assessment-status`;
export const FORCE_DELETE_SKILL_ASSESSMENTS = `${TALENAISE_BASE_URL}/v1/api/skill-assessment/force`;

export const CRUD_TEMPLATE_TYPE = `${TALENAISE_BASE_URL}/v1/api/assessment-type`;
export const CRUD_QUESTION_CATEGORY = `${EVALTIQ_BASE_URL}/v1/api/question-category`;

export const CRUD_ASSESSMENT_TEMPLATE = `${TALENAISE_BASE_URL}/v1/api/assessment-template`;

// Publish Assessment
export const GET_PUBLISH_ASSESSMENT_BY_ASSESSMENT_TYPE = `${TALENAISE_BASE_URL}/v1/api/assessment-tracking/by-type`;
export const CRUD_PUBLISH_ASSESSMENT_ARCHIVE_BY_ASSESSMENT_TYPE = `${TALENAISE_BASE_URL}/v1/api/assessment-tracking/archived-by-type`;
export const CRUD_MAP_ASSESSOR = `${TALENAISE_BASE_URL}/v1/api/assessor-mapping`;

export const CRUD_SKILL_ASSESSMENT = `${TALENAISE_BASE_URL}/v1/api/skill-assessment`;

export const SKILL_ASSESSMENT_PREVIEW = `${TALENAISE_BASE_URL}/v1/api/assessment-preview/client/fetch-assessment-preview`;
export const SKILL_ASSESSMENT_PREVIEW_RESPONSE = `${TALENAISE_BASE_URL}/v1/api/assessment-preview/client/update-assessment-preview-response`;

export const GET_ASSESSMENT_DETAILS = `${TALENAISE_BASE_URL}/v1/api/skill-assessment/get-by-id`;

export const PUBLISH_SKILL_ASSESSMENT = `${TALENAISE_BASE_URL}/v1/api/skill-assessment/publish-assessment`;
export const GET_ARCHIEVED_SKILL_ASSESSMENT = `${TALENAISE_BASE_URL}/v1/api/skill-assessment/archived`;

export const CRUD_SKILL_ASSESSMENT_ASSESSOR = `${TALENAISE_BASE_URL}/v1/api/participant`;

export const UPLOAD_USER = `${TALENAISE_BASE_URL}/v1/api/excel-parser/batch-upload-participant`;
export const DOWNLOAD_USER = `${TALENAISE_BASE_URL}/v1/api/excel-parser/download-participant-template`;

export const GET_SKILL_ASSESSMENT_ASSESSOR = `${TALENAISE_BASE_URL}/v1/api/participant/get-by-skill-assessment-id`;
export const GET_ALERT_DELETE_ASSESSOR = `${TALENAISE_BASE_URL}/v1/api/participant/alert-delete-participant`;
export const GET_SKILL_ASSESSMENT_ASSESSOR_BY_ID = `${TALENAISE_BASE_URL}/v1/api/participant/get-all-participants-by-id`;


export const CRUD_COMPETENCY_FRAMEWORK_CONFIG = `${TALENAISE_BASE_URL}/v1/api/competency-framework-config`;

export const CREATE_COMPETECY_FRAMEWORK_PREDEFINED = `${TALENAISE_BASE_URL}/v1/api/competency-framework/clone-from-config`;

export const FORCE_DELETE_COMPETENCY_FRAMEWORK_PROJECT_LEVEL = `${TALENAISE_BASE_URL}/v1/api/competency-framework/force`;

export const CRUD_COMPETENCY_FRAMEWORK = `${TALENAISE_BASE_URL}/v1/api/competency-framework`;

export const GET_COMP_FRAMEWORK_BY_ACCONUT_ID = `${TALENAISE_BASE_URL}/v1/api/competency-framework-config/get-by-account`;
export const GET_COMP_FRAMEWORK_BY_PROJECT_ID = `${TALENAISE_BASE_URL}/v1/api/competency-framework/get-by-project`;
export const GET_ALL_LEVEL_PUBLISHED_COMPETENCY_FRAMEWORK = `${TALENAISE_BASE_URL}/v1/api/competency-framework/all-level-published`;

export const GET_PUBLISHED_COMPETENCY_FRAMEWORK_SETUP = `${TALENAISE_BASE_URL}/v1/api/competency-framework-config/published`;

export const GET_ARCHIVED_COMPETENCY_FRAMEWORK = `${TALENAISE_BASE_URL}/v1/api/competency-framework/archived`;

export const GET_COMPETENCY_FRAMEWORK_DETAILS = `${TALENAISE_BASE_URL}/v1/api/competency-framework/get-by-id`;
export const GET_COMPETENCY_FRAMEWORK_DETAILS_SETUP = `${TALENAISE_BASE_URL}/v1/api/competency-framework-config/get-by-id`;

export const GET_COMPETENCY_FRMEWORKL_STATUS_HISTORY = `${TALENAISE_BASE_URL}/v1/api/framework-status-history`;
export const GET_COMPETENCY_FRMEWORKL_STATUS_HISTORY_SETUP = `${TALENAISE_BASE_URL}/v1/api/framework-status-history/config`;

export const CRUD_EVALUATION_METHOD = `${TALENAISE_BASE_URL}/v1/api/evaluation-method`;
export const FORCE_DELETE_EVALUATION_METHOD = `${TALENAISE_BASE_URL}/v1/api/evaluation-method/force`;

export const UPLOAD_COMPETENCY_FRAMEWORK = `${TALENAISE_BASE_URL}/v1/api/excel-parser/batch-upload-competency-framework`;
export const DOWNLOAD_COMPETENCY_FRAMEWORK = `${TALENAISE_BASE_URL}/v1/api/excel-parser/excel-download-competency-framework-template`;

// Report Assessment
export const CRUD_ASSESSORS_RESPONSE_LIST = `${TALENAISE_BASE_URL}/v1/api/assessment-tracking/get-all-accessors-by-id`;
export const GET_SKILLIQ_ASSESSMENT_BOOLEAN_RESPONSE = `${TALENAISE_BASE_URL}/v1/api/skill-assessment/boolean-report`;
export const GET_SKILLIQ_ASSESSMENT_ALL_TYPES_RESPONSE = `${TALENAISE_BASE_URL}/v1/api/skill-assessment/full-report`;

export const CRUD_REMAINDER_RESPONSE_LIST = `${TALENAISE_BASE_URL}/v1/api/assessment-tracking-reminder`;
export const POST_REMAINDER_RESPONSE_LIST_SKILL_IQ = `${TALENAISE_BASE_URL}/v1/api/skill-assessment-reminder`;
export const SEND_REMINDER_MAIL = `${TALENAISE_BASE_URL}/v1/api/assessment-tracking/send-reminder-email`;
export const SEND_REMINDER_MAIL_SKILL_IQ = `${TALENAISE_BASE_URL}/v1/api/skill-assessment/send-reminder-email`;

export const DOWNLOAD_SKILLIQ_ASSESSMENT_REPORT = `${TALENAISE_BASE_URL}/v1/api/skill-assessment/skill-assessment-report`;
export const GET_ANALYSIS_REPORT = `${TALENAISE_BASE_URL}/v1/api/analysis-report/get-by-assessment-user-id`;
export const STORE_GENERATED_ANALYSIS_REPORT = `${TALENAISE_BASE_URL}/v1/api/analysis-report`;

// Gap analysis
export const CRUD_GAP_ANALYSIS = `${TALENAISE_BASE_URL}/v1/api/gap-analysis-documentation`;
export const GET_GAP_ANALYSIS = `${TALENAISE_BASE_URL}/v1/api/gap-analysis-documentation/findByAssessmentTrackingId`;

// dashboard
export const GET_DASHBOARD_SKILL_ASSESSMENT_TREND = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/skill-assessment-report`;

export const GET_DASHBOARD_SKILL_ASSESSMENT_STATUS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/skill-assessment-status`;
export const GET_DASHBOARD_COMPETENCY_FRAMEWORK_STATUS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/competency-framework-status`;
export const GET_DASHBOARD_RESPONSE_STATUS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/response-status`;

export const GET_DASHBOARD_TOTAL_ASSESSMENT = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/total-skill-assessments`;
export const GET_DASHBOARD_EXPIRED_ASSESSMENTS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/expired-skill-assessment`;
export const GET_DASHBOARD_UPCOMING_ASSESSMENTS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/upcoming-skill-assessment`;
export const GET_DASHBOARD_PUBLISHED_ASSESSMENTS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/published-skill-assessment`;

export const GET_ASSESSMENT_STATUS_DETAILS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/skill-assessment-status/details`;
export const GET_DASHBOARD_COMPETENCY_FRAMEWORK_DETAILS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/competency-framework-status/details`;
export const GET_RESPONSE_STATUS_DETAILS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/response-status/details`;
export const GET_SKILL_ASSESSMENT_TREND_DETAILS = `${TALENAISE_BASE_URL}/v1/api/dashboard-graph/skill-assessment-report/details`;
